// Storage may be unavailable or contain a partially written/old session.
// Reading a session must never prevent the login page from rendering.
export function readSession() {
  try {
    const token = localStorage.getItem('token');
    const rawUser = localStorage.getItem('userData');
    const user = rawUser ? JSON.parse(rawUser) : null;
    if (!token || token === 'undefined' || token === 'null' ||
        !user || typeof user !== 'object' || Array.isArray(user) ||
        typeof user._id !== 'string' || !user._id.trim()) {
      return null;
    }
    return { token, user };
  } catch {
    return null;
  }
}
